module.exports = __webpack_public_path__ + "static/media/grunge.5130c32d.png";